<div class="relative box-border flex h-14 items-center justify-between bg-neutral-800 pr-6">
  <div class="z-10 flex items-center gap-6">
    <rl-button class="p-2" type="silent" icon="{{ navOpen ? 'close' : 'menu' }}" (click)="toggleMenu($event)"></rl-button>
    <img alt="Rillion" class="h-6" src="assets/images/rillion_logo.png" />
    <rl-button type="silent" text="Use the old experience" (buttonClickEvent)="gotoOldExperience()"></rl-button>
  </div>

  <div class="absolute z-0 flex w-full flex-col items-center whitespace-nowrap text-md-bold">
    <div>
      @for (route of routes; track route; let last = $last) {
        @if (!last) {
          <a [routerLink]="route.link" class="text-primary-medium">{{ route.text }}</a>
        }
        @if (last) {
          <span>{{ route.text }}</span>
        }
        @if (!last) {
          <span> / </span>
        }
      }
    </div>
  </div>

  <button
    class="z-10 flex items-center text-md-bold text-primary-medium"
    (click)="openUser.emit()"
    [disabled]="disableRoleSelect$ | async"
    [class.opacity-50]="disableRoleSelect$ | async"
  >
    {{ user }} | {{ role }}
    <mat-icon class="material-icons-outlined">arrow_drop_down</mat-icon>
  </button>
</div>
